import React, { useContext, useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { appContext } from '../../App';
import { lang } from '../../util/constants';

import './language-selector.css';

const LanguageSelector = () => {

   const [isClosed, setIsClosed] = useState(false);

   const { setLanguage } = useContext(appContext);

   const storageLang = localStorage.getItem('language');

   function setLang(lang: string) {
      setLanguage(lang)
      setIsClosed(true);
   }
// !storageLang
   return false ? (
      <div className='ls-container' style={isClosed ? {display: 'none'} : {}}>
         <div className='ls p-4'>
            <div className='ls-close' onClick={() => setIsClosed(true)}><AiOutlineClose /></div>
            <p>Idioma / Language</p>
            <div className=''>
               <div className='ls-language' onClick={() => setLang(lang.en)} style={{marginBottom: '1rem'}}>
                  <div className='ls-l-img ls-l-img1'></div>
                  <div className='ls-en-text'>English</div>
               </div>
               
               <div className='ls-language' onClick={() => setLang(lang.pt)}>
                  <div className='ls-l-img ls-l-img2'></div>
                  <div className='ls-en-text'>Portugues</div>
               </div>
            </div>
         </div>
      </div>
   ) :
   null
}

export default LanguageSelector
